import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';

import { AkciiDetail } from './akciidetail';
import { CatalogItems } from 'vpl.tas.listing';
import { SmartFilter } from 'vpl.tas.listing';


export const AkciiDetailPage = {
    components: {
        ItemEditBtns,
        AkciiDetail,
        SmartFilter,
        CatalogItems
    },
    props: {
        structKey: [String, Number],
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    methods: {

    },
    mounted(){

    },
    template: `
<div>
<section class="section section--gray section--bg2">
    <div class="container">
        <AkciiDetail :structKey="this.structKey" />
    </div>
</section>
<section v-if="this.struct[this.structKey].componentData.BOTTOM_TEXT" class="section section--gray3">
    <div class="container">
        <div class="text-block content" v-html="this.struct[this.structKey].componentData.BOTTOM_TEXT">
        </div>
    </div>
</section>
<section v-if="this.struct[this.structKey].componentData.HAS_PRODUCTS === true" class="section promo-detail">
    <div class="container">
        <div class="catalog-wp">
            <div class="catalog__bottom js-catalog-wp">
                <SmartFilter :structKey="this.structKey" />
                <CatalogItems :structKey="this.structKey" />
            </div>
        </div>
    </div>
</section>
</div>
    `
}